export const LEGAL_ENTITY = "Pacific Crest Holdings LLC";
export const BRAND_NAME = "Pacific Crest Properties";
export const AFFILIATED_BRAND = "Phil Buys Florida";
export const COMPLIANCE_EMAIL = "office@pacificcrestprop.com";
export const MAILING_ADDRESS_LINES = [
  "732 S 6TH ST",
  "STE N",
  "LAS VEGAS NV 89101",
];
export const GOVERNING_LAW_STATE = "Nevada";
